module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAyBAMAAADy2KUxAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAPUExURUdwTP///////////////xPgMRoAAAAEdFJOUwAg38eIfq65AAAAi0lEQVQ4y+2R0Q2AIAxEYQOsE2gYQBIHMMD+M9miCY3Y8uGn3A+By8uVnjGfNGdFweyanUxW1aM72UOj0F/LhkehyXEbIl15JRuHfV7w4A0cHKa+RBrhQgvZCEcnj33DrSYVtqvTYKB3GfZoyHBxlLHJEuEL1/4MZC/qRircLhU43FZiPUt+KRQqfAJa2XpXVeByggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notification/readAll.png
// module id = 1822
// module chunks = 0